import { render, staticRenderFns } from "./WitcherBottomNavigator.vue?vue&type=template&id=523c2892&scoped=true&"
import script from "./WitcherBottomNavigator.vue?vue&type=script&lang=js&"
export * from "./WitcherBottomNavigator.vue?vue&type=script&lang=js&"
import style0 from "./WitcherBottomNavigator.vue?vue&type=style&index=0&id=523c2892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c2892",
  null
  
)

export default component.exports